import React from 'react';
import DesktopSearch from './DesktopSearch';
import OpenModalButton from './OpenModalButton';
import useLandingSearchLogic from './useLandingSearchLogic';

const LandingSearch = () => {
  const { mobile } = useLandingSearchLogic();
  return mobile ? <OpenModalButton /> : <DesktopSearch />;
};

export default LandingSearch;
